import axios from 'axios';

const webResourceClient = axios.create({
  timeout: 120 * 1000,
  headers: {
    'Cache-Control': 'no-cache',
    Pragma: 'no-cache',
  },
});

export default webResourceClient;
